import { CHCSearch } from "./search.component.js";
customElements.define("chc-search", CHCSearch);
export {
  CHCSearch
};
//# sourceMappingURL=search.js.map
